import React from 'react'
import '../../../../assets/react-toolbox/theme.css';
import theme from '../../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import Button from 'react-toolbox/lib/button/Button';
import Input from 'react-toolbox/lib/input';

const gasPercentages = {
    o3: 0.5,
    no: 0.8,
    co: 0.7,
    no2: 1,
    pm10: 0.6,
    pm2: 0.5,
    pm1: 0.3
};

const maxGasAQI = {
    o3: 70,
    no: 100,
    co: 9.4,
    no2: 100,
    pm10: 154,
    pm2: 35.4,
    pm1: 35.4
};

let values = {
    value: 0,
    dummie: 0,
    o3: 0,
    no: 0,
    co: 0,
    no2: 0,
    pm10: 0,
    pm2: 0,
    pm1: 0,
};

const IoTGasCalculator = (gasName) => {
    let value = (values.value*maxGasAQI[gasName]/100)*gasPercentages[gasName]
    return value.toFixed(2)
};

const handleChange = (event) => {
    values.dummie = event;
};

export const DummyForm = (props) => {

    console.log(props.value)

    values.value = Math.round(props.value);
    values.dummie = props.adminValue

    let idLength = props.id.length;
    const newId = props.id.substring(idLength - 2, idLength) + ":" + props.id.substring(idLength - 6, idLength - 4);

    values = {
        ...values,
        o3: IoTGasCalculator('o3'),
        no: IoTGasCalculator('no'),
        co: IoTGasCalculator('co'),
        no2: IoTGasCalculator('no2'),
        pm10: IoTGasCalculator('pm10'),
        pm2: IoTGasCalculator('pm2'),
        pm1: IoTGasCalculator('pm1'),
    };

    return (

        <ThemeProvider theme={theme}>
            <div className="sensorForm">
                <span className="sensorId">Sensor {newId.toUpperCase()}</span>
                <br/>
                <span className="sensorInfo">Lat: {props.coordinates[0].toFixed(3)} </span>
                <br/>
                <span className="sensorInfo">Lon: {props.coordinates[1].toFixed(3)}</span>
                <div className="sensorInfoValues">
                    <span className="sensorAQIValue"><b>AQI</b>: {values.value}</span><br/>
                    <span className="sensorAQIValue"><b>O<sub>3</sub></b>: {values.o3} (ppb)</span><br/>
                    <span className="sensorAQIValue"><b>NO</b>: {values.no} (ppb)</span><br/>
                    <span className="sensorAQIValue"><b>CO</b>: {values.co} (ppm)</span><br/>
                    <span className="sensorAQIValue"><b>NO<sub>2</sub></b>: {values.no2} (ppb)</span><br/>
                    <span className="sensorAQIValue"><b>PM<sub>10</sub></b>: {values.pm10} (mg/m<sup>3</sup>)</span><br/>
                    <span className="sensorAQIValue"><b>PM<sub>2</sub></b>: {values.pm2} (mg/m<sup>3</sup>)</span><br/>
                    <span className="sensorAQIValue"><b>PM<sub>1</sub></b>: {values.pm1} (mg/m<sup>3</sup>)</span><br/>
                    <br/>
                </div>
                {props.isAdmin &&
                <div className="adminSensorForm">
                    <Input type="text"
                           onChange={handleChange}
                           value={values.dummie}
                    />
                    <div className="sensorForm buttons">
                        <Button onClick={() => props.storeDummie(values.dummie)}
                                raised accent>Submit</Button>
                        <Button onClick={props.deleteSingleDummie}
                                raised accent>Delete</Button>
                    </div>
                </div>
                }

            </div>
        </ThemeProvider>
    );
};



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/sensors/DummyForm.js